export const DOKA_360_COMPLETE_REGISTRATION_URL = import.meta.env.VITE_APP_DOKA_360_COMPLETE_REGISTRATION_URL;
